import React from "react";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { bool, func, oneOf, shape, string } from "prop-types";

import InquirySuccess from "../../../../shared/components/InquirySuccess";
import ENTITY_TYPES from "../../constants/entityTypes";
import INQUIRY_TYPES from "../../constants/inquiryTypes";
import VIEW_TYPES from "../../constants/viewTypes";
import InterestedSellerForm from "../InterestedSellerForm";
import * as S from "./styled";

const ariaContentDescribedBy = "modal-content-description";
const ariaContentLabelledBy = "modal-content-label";

const InterestedSellerModal = ({
  className,
  entityType,
  handleFormSubmit,
  handleRequestClose,
  initialFormValues,
  inquiryType,
  isOpen,
  rootElementId,
  view
}) => (
  <S.Modal
    aria={{
      describedby: ariaContentDescribedBy,
      labelledby: ariaContentLabelledBy
    }}
    className={className}
    isOpen={isOpen}
    onRequestClose={handleRequestClose}
    rootElementId={rootElementId}
  >
    <S.CloseButtonWrapper>
      <XButton onClick={handleRequestClose} />
    </S.CloseButtonWrapper>
    {view === VIEW_TYPES.form ? (
      <InterestedSellerForm
        ariaContentDescribedBy={ariaContentDescribedBy}
        ariaContentLabelledBy={ariaContentLabelledBy}
        entityType={entityType}
        handleFormSubmit={handleFormSubmit}
        initialFormValues={initialFormValues}
        inquiryType={inquiryType}
      />
    ) : (
      <InquirySuccess
        ariaContentDescribedBy={ariaContentDescribedBy}
        ariaContentLabelledBy={ariaContentLabelledBy}
      >
        What&apos;s next? A StreetEasy Advisor will reach out to you shortly!
      </InquirySuccess>
    )}
  </S.Modal>
);

InterestedSellerModal.propTypes = {
  className: string,
  entityType: string,
  handleFormSubmit: func.isRequired,
  handleRequestClose: func.isRequired,
  initialFormValues: shape({
    name: string,
    email: string,
    phone_number: string,
    notes: string,
    contact_preferences: shape({
      email: bool,
      call: bool,
      text: bool
    })
  }).isRequired,
  inquiryType: oneOf(Object.values(INQUIRY_TYPES)).isRequired,
  isOpen: bool.isRequired,
  rootElementId: string.isRequired,
  view: oneOf(Object.values(VIEW_TYPES)).isRequired
};

InterestedSellerModal.defaultProps = {
  className: "",
  entityType: ENTITY_TYPES.sale
};

export default InterestedSellerModal;
